export default __webpack_public_path__ + "static/media/Hug_too.072f522f.jpg";